export class FetchActivitiesByQueryCommand {
  private _query: string
  private _languageCode: string

  constructor (query: string, languageCode: string) {
    this._query = query
    this._languageCode = languageCode
  }

  query (): string {
    return this._query
  }

  languageCode (): string {
    return this._languageCode
  }
}
